import React from "react";
import s3 from "react-aws-s3";
//import AWS from "aws-sdk";


const accessKeyId = atob("QUtJQVNYTkRCQkVONTIzTVhTRVM="); 
const secretAccessKey = atob("SXlxOHRGRDFCd0MyYTBjeUhBaXNxYjR1c3FWemJSRnpBL3pwR3Zuag=="); 

const config = {
  bucketName: "images-nwlt",
  albumName: "photos",
  region: "us-west-2",
  accessKeyId: accessKeyId,
  secretAccessKey: secretAccessKey,
};
  
export async function amazonUpload(files) {
  let s3Client = new s3(config);
  return s3Client
    .uploadFile(files.target.files[0], files.target.files[0].name)
    .then((data) => data)
    .catch((err) => console.error(err));
}
